export default "__VITE_ASSET__Bg2caGj8__"